module.exports = __webpack_public_path__ + "static/media/leaf.afdff21f.svg";